// 5. Composant pour les cartes d'information du récapitulatif
// components/consultation/summary/InfoCard.tsx
import React, { type ReactNode } from 'react';

interface InfoCardProps {
  title: string;
  icon: string;
  iconColor: string;
  borderColor: string;
  children: ReactNode;
  onEdit?: () => void;
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  icon,
  iconColor,
  borderColor,
  children,
  onEdit,
}) => {
  return (
    <div className={`bg-white rounded-2xl shadow border ${borderColor} p-6`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className={`${iconColor} text-xl`}>{icon}</span>
          <span className={`font-semibold ${iconColor.replace('text-', 'text-').replace('-500', '-700')}`}>
            {title}
          </span>
        </div>
        {onEdit && (
          <button
            type="button"
            className={`text-sm ${iconColor.replace('text-', 'bg-')} text-white px-3 py-1 rounded-lg hover:${iconColor.replace('text-', 'bg-').replace('-500', '-600')}`}
            onClick={onEdit}
          >
            Modifier
          </button>
        )}
      </div>
      {children}
    </div>
  );
};